
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const HeroSection = () => {
  const { handleSignIn, isAuthenticated, handleDashboard } = useAuth();

  return (
    <div className="relative min-h-screen overflow-hidden">
      <div className="fixed inset-0 bg-gradient-to-r from-purple-800/20 to-blue-800/20 z-0" />
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-24 relative z-10">
        <div className="text-center space-y-8 animate-in">
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-white">
            Run Your Venue Smarter –
            <br />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400">
              Create Events & Scan IDs in Seconds
            </span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            ClubMate helps you manage events, sell tickets, and streamline entry with AI-powered scanning.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            {!isAuthenticated ? (
              <>
                <Button
                  size="lg"
                  className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-full px-8 shadow-[0_0_15px_rgba(139,92,246,0.5)] hover:shadow-[0_0_25px_rgba(139,92,246,0.65)] transition-all duration-300"
                  onClick={handleSignIn}
                >
                  Sign Up Now – Get Started Free
                </Button>
                <Button
                  size="lg"
                  className="bg-gradient-to-r from-gray-900 to-gray-800 hover:from-gray-800 hover:to-gray-700 text-white rounded-full px-8 border-2 border-purple-500/50 shadow-[0_0_15px_rgba(139,92,246,0.25)] hover:shadow-[0_0_20px_rgba(139,92,246,0.4)] transition-all duration-300"
                  onClick={handleSignIn}
                >
                  Sign In – Manage Your Venue
                </Button>
              </>
            ) : (
              <Button
                size="lg"
                className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-full px-8 shadow-[0_0_15px_rgba(139,92,246,0.5)] hover:shadow-[0_0_25px_rgba(139,92,246,0.65)] transition-all duration-300"
                onClick={handleDashboard}
              >
                Go to Dashboard
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
